var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-flex uk-flex-column house-panel"},[_c('div',{staticClass:"uk-flex uk-flex-row house-menu"},[_c('div',{staticClass:"uk-flex uk-flex-row house-fiber"},[_c('router-link',{staticClass:"router-link-tarif-menu",attrs:{"to":"/internet/house-panel/fiber"}},[_vm._v("Оптичне підключення")])],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }